import { useQuery } from '@tanstack/react-query';
import { fetchSelectOptions } from '@/components/formBuilder/helpers/formHelpers';

export interface InternalEmailTemplate {
  id?: string | number;
  name?: string;
  subject?: string;
  body?: string;
  /** Kinds of candidate document a send from this template offers to attach. */
  attach_document_kinds?: string[];
  /** Files that go out with every send of this template. */
  attachments?: {
    id?: number;
    blob_id?: number;
    filename?: string;
    content_type?: string;
    byte_size?: number;
    url?: string;
  }[];
}

// Byte-identical to what `ChooseTemplate` builds for this category, and cached under
// the same key — the interview plan's picker and the composer's are the same list, and
// two spellings of it would fetch 200 templates twice.
const ENDPOINT =
  '/ats_comm_templates?filter_by[channel]=email&filter_by[category][]=internal_email_notice&items=200&filter_by[name]=';

/**
 * The internal email templates the sender may compose from.
 *
 * Templates in this category are written for teammates, not candidates, which is why
 * the composer offers these rather than the candidate-facing set.
 */
export const useInternalEmailTemplates = () =>
  useQuery<InternalEmailTemplate[]>({
    queryKey: ['ats-comm-templates', ENDPOINT],
    queryFn: () =>
      fetchSelectOptions({ endPoint: ENDPOINT }).then(
        (list: InternalEmailTemplate[] | undefined) => list ?? []
      ),
    // Long enough that opening the drawer twice does not refetch, short enough that a
    // template written in another tab shows up.
    staleTime: 30 * 1000,
  });
